__turbopack_context__.v({
  "accountPrompt": "login-page-module__6Idf6q__accountPrompt",
  "ambientGlow": "login-page-module__6Idf6q__ambientGlow",
  "authContent": "login-page-module__6Idf6q__authContent",
  "consoleFloat": "login-page-module__6Idf6q__consoleFloat",
  "errorMessage": "login-page-module__6Idf6q__errorMessage",
  "field": "login-page-module__6Idf6q__field",
  "forgotPassword": "login-page-module__6Idf6q__forgotPassword",
  "form": "login-page-module__6Idf6q__form",
  "formCard": "login-page-module__6Idf6q__formCard",
  "formMark": "login-page-module__6Idf6q__formMark",
  "inputShell": "login-page-module__6Idf6q__inputShell",
  "intro": "login-page-module__6Idf6q__intro",
  "leftVisual": "login-page-module__6Idf6q__leftVisual",
  "loaderTurn": "login-page-module__6Idf6q__loaderTurn",
  "loginContentIn": "login-page-module__6Idf6q__loginContentIn",
  "loginLeftIn": "login-page-module__6Idf6q__loginLeftIn",
  "loginRightIn": "login-page-module__6Idf6q__loginRightIn",
  "mobileVisuals": "login-page-module__6Idf6q__mobileVisuals",
  "page": "login-page-module__6Idf6q__page",
  "passwordToggle": "login-page-module__6Idf6q__passwordToggle",
  "rightVisual": "login-page-module__6Idf6q__rightVisual",
  "spinner": "login-page-module__6Idf6q__spinner",
  "stage": "login-page-module__6Idf6q__stage",
  "submitButton": "login-page-module__6Idf6q__submitButton",
  "trophyFloat": "login-page-module__6Idf6q__trophyFloat",
  "turnstileWrap": "login-page-module__6Idf6q__turnstileWrap",
  "visualHalo": "login-page-module__6Idf6q__visualHalo",
});
